var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicesA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 391.511,
    height: 402.474,
    viewBox: "0 0 391.511 402.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_33",
    x: 260,
    y: 18,
    width: 116.126,
    height: 116.126,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_48",
    x: 275.385,
    y: 165.624,
    width: 116.126,
    height: 116.126,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_185",
    x: 76.437,
    y: 286.348,
    width: 116.126,
    height: 116.126,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_43",
    x: 130,
    y: 0,
    width: 116.126,
    height: 116.126,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_42",
    x: 148.524,
    y: 144.187,
    width: 116.126,
    height: 116.126,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_39",
    x: 22.874,
    y: 152.174,
    width: 116.126,
    height: 116.126,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_184",
    x: 201.973,
    y: 285,
    width: 116.126,
    height: 116.126,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_35",
    x: 0,
    y: 18,
    width: 116.126,
    height: 116.126,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404",
    transform: "translate(-839.5 -243.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "water_usage",
    transform: "translate(-16 -359.528)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 855.5, 603.03)",
    filter: "url(#Path_33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33-2",
    "data-name": "Path 33",
    d: "M5.277,0h96.572a5.277,5.277,0,0,1,5.277,5.277v96.572a5.277,5.277,0,0,1-5.277,5.277H5.277A5.277,5.277,0,0,1,0,101.849V5.277A5.277,5.277,0,0,1,5.277,0Z",
    transform: "translate(264.5 21.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Modal",
    transform: "translate(1174 705)",
    fill: "#636363",
    fontSize: 14,
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontWeight: 700,
    letterSpacing: "0.017em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -41.865,
    y: 0
  }, "Water Usage")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(1159 649.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M25.859,27.29,24.8,28.44a1.689,1.689,0,0,0,0,2.3,1.509,1.509,0,0,0,1.055.475,1.488,1.488,0,0,0,1.055-.475,1.689,1.689,0,0,0,0-2.3Z",
    transform: "translate(1.35 1.513)",
    fill: "#efc700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M25.67,23.53,24.414,22.2l-1.267,1.33a1.963,1.963,0,0,0,0,2.67,1.72,1.72,0,0,0,2.522,0,1.942,1.942,0,0,0,0-2.67Z",
    transform: "translate(1.254 1.231)",
    fill: "#efc700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M24.425,22.32V14.267A2.427,2.427,0,0,0,22,11.84H3.485a1.055,1.055,0,1,0,0,2.111H22.029a.317.317,0,0,1,.317.317V22.32a1.055,1.055,0,0,0,2.111,0Z",
    transform: "translate(0.135 0.656)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M24.159,6.744H15.272V5.277a5.508,5.508,0,0,1,1.245.095l1.625.179h.116a2.776,2.776,0,0,0,0-5.552L16,.264a14.407,14.407,0,0,1-3.567,0L10.29,0h-.127a2.776,2.776,0,0,0,0,5.541l1.741-.179c.422,0,.834-.074,1.256-.095V6.744H1.055a1.055,1.055,0,1,0,0,2.111h23.1a3.462,3.462,0,0,1,3.451,3.451v10.67a1.055,1.055,0,1,0,2.111,0V12.306a5.573,5.573,0,0,0-5.562-5.562ZM11.684,3.261l-1.562.169A.654.654,0,0,1,9.5,2.776a.665.665,0,0,1,.623-.665l2.058.253a17.531,17.531,0,0,0,4.074,0l2.111-.253a.675.675,0,0,1,.612.665.654.654,0,0,1-.623.654l-1.562-.169a25.078,25.078,0,0,0-2.575-.095h0A22.581,22.581,0,0,0,11.684,3.261Z",
    fill: "#1787e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "report_incident",
    transform: "translate(122.385 -225.376)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 717.11, 454.88)",
    filter: "url(#Rectangle_48)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48-2",
    "data-name": "Rectangle 48",
    width: 107.126,
    height: 107.126,
    rx: 5,
    transform: "translate(279.89 169.12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Modal-2",
    "data-name": "Modal",
    transform: "translate(1051 705)",
    fill: "#636363",
    fontSize: 14,
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontWeight: 700,
    letterSpacing: "0.017em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.653,
    y: 0
  }, "Report "), /*#__PURE__*/React.createElement("tspan", {
    x: -26.444,
    y: 17
  }, "Incident")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2",
    transform: "translate(1029 651.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M36.317,8.158l.528-1.425a.654.654,0,0,0-.781-.865L24.391,10.153H21.9a2.755,2.755,0,0,0-2.786,2.375,2.639,2.639,0,0,0,2.639,2.913h.739v2.28a.95.95,0,1,0,1.9,0v-2.28l.781.222a11.409,11.409,0,0,1-2.248,5.14,11.61,11.61,0,1,1-9.2-18.692A1.055,1.055,0,1,0,13.72,0,13.721,13.721,0,1,0,24.6,22.09a13.51,13.51,0,0,0,2.607-5.868l8.908,2.449a.665.665,0,0,0,.718-.865C35.736,14.628,35.135,11.3,36.317,8.158Z",
    transform: "translate(-0.008)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M36.779,9.178a1.055,1.055,0,0,0-1.815-1.055,6.934,6.934,0,0,0,0,6.554,1.055,1.055,0,0,0,.939.57,1.172,1.172,0,0,0,.485-.116,1.055,1.055,0,0,0,.443-1.425A4.8,4.8,0,0,1,36.779,9.178Z",
    transform: "translate(1.884 0.426)",
    fill: "#efc700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M40.832,15.585a8.623,8.623,0,0,1,0-8.127A1.055,1.055,0,0,0,39.017,6.4a10.829,10.829,0,0,0,0,10.206,1.043,1.043,0,1,0,1.815-1.024Z",
    transform: "translate(2.084 0.331)",
    fill: "#efc700"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "other_services",
    transform: "translate(-12.437 -90.652)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 793.06, 334.15)",
    filter: "url(#Path_185)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_185-2",
    "data-name": "Path 185",
    d: "M5,0h97.126a5,5,0,0,1,5,5v97.126a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
    transform: "translate(80.94 289.85)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Modal-3",
    "data-name": "Modal",
    transform: "translate(928 705)",
    fill: "#636363",
    fontSize: 14,
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontWeight: 700,
    letterSpacing: "0.017em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.547,
    y: 0
  }, "Other "), /*#__PURE__*/React.createElement("tspan", {
    x: -29.381,
    y: 17
  }, "Services ")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-3",
    "data-name": "Layer 2",
    transform: "translate(911 645.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-3",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M16.326,15.829l4.391-4.623a6.818,6.818,0,0,0,0-9.246,5.984,5.984,0,0,0-8.771,0,6.776,6.776,0,0,0,0,9.246Z",
    transform: "translate(0.551 -0.048)",
    fill: "#efc700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M32.781,21.26a10.069,10.069,0,0,0-2.807.4c-1.815.391-4.3.939-5.932.486-2.4-.654-4.053.169-5.8,1.055l-1.055.528a.675.675,0,0,1-.57,0l-2.776-1.277a10.238,10.238,0,0,0-6.005-.633A14.871,14.871,0,0,1,1.5,21.355H1.372A1.047,1.047,0,0,0,.01,22.368a16.887,16.887,0,0,0,33.71,0,1.055,1.055,0,0,0-.939-1.108ZM16.886,37.06A14.776,14.776,0,0,1,2.174,23.7a17,17,0,0,0,5.9.2,8.285,8.285,0,0,1,4.834.454l2.776,1.288a2.839,2.839,0,0,0,2.343,0l1.15-.559c1.615-.813,2.681-1.34,4.306-.9,2.111.591,4.908,0,6.934-.464l1.129-.232A14.776,14.776,0,0,1,16.886,37.06Z",
    transform: "translate(-0.01 1.128)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M9.957,26.285A1.055,1.055,0,0,0,8.9,25.23H5.735a1.055,1.055,0,1,0,0,2.111H8.9A1.055,1.055,0,0,0,9.957,26.285Z",
    transform: "translate(0.249 1.348)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M13.055,28.771h3.166a1.055,1.055,0,1,0,0-2.111H13.055a1.055,1.055,0,0,0,0,2.111Z",
    transform: "translate(0.655 1.427)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M22.962,29.111a1.055,1.055,0,0,0,0-2.111H19.8a1.055,1.055,0,0,0,0,2.111Z",
    transform: "translate(1.028 1.446)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M28.322,24.9H25.155a1.055,1.055,0,0,0,0,2.111h3.166a1.055,1.055,0,0,0,0-2.111Z",
    transform: "translate(1.325 1.329)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M11.382,29.53H8.215a1.055,1.055,0,1,0,0,2.111h3.166a1.055,1.055,0,1,0,0-2.111Z",
    transform: "translate(0.386 1.586)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M16.222,33H13.055a1.055,1.055,0,0,0,0,2.111h3.166a1.055,1.055,0,1,0,0-2.111Z",
    transform: "translate(0.655 1.778)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M18.148,29.81H15.055a1.055,1.055,0,0,0,0,2.111h3.166a1.055,1.055,0,0,0,0-2.111Z",
    transform: "translate(0.766 1.602)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M23.962,30.25H20.8a1.055,1.055,0,1,0,0,2.111h3.166a1.055,1.055,0,0,0,0-2.111Z",
    transform: "translate(1.084 1.626)",
    fill: "#1787e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "maji_loan",
    transform: "translate(223 -377.528)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 616.5, 621.03)",
    filter: "url(#Rectangle_43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43-2",
    "data-name": "Rectangle 43",
    width: 107.126,
    height: 107.126,
    rx: 5,
    transform: "translate(134.5 3.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Modal-4",
    "data-name": "Modal",
    transform: "translate(805 705)",
    fill: "#636363",
    fontSize: 14,
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontWeight: 700,
    letterSpacing: "0.017em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -30.912,
    y: 0
  }, "Maji Loan"), /*#__PURE__*/React.createElement("tspan", {
    x: -33.714,
    y: 17
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-4",
    "data-name": "Layer 2",
    transform: "translate(789 644.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-4",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M23.738,25.28l-2.533,2.681a3.926,3.926,0,0,0,0,5.351,3.462,3.462,0,0,0,5.077,0,3.926,3.926,0,0,0,0-5.351Z",
    transform: "translate(1.117 1.401)",
    fill: "#efc700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M4.325,9.041h11.05a1.055,1.055,0,0,0,0-2.111H4.325a1.055,1.055,0,1,0,0,2.111Z",
    transform: "translate(0.181 0.384)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M21.149,21.235a1.055,1.055,0,0,0-1.055-1.055H4.325a1.055,1.055,0,0,0,0,2.111H20.094A1.055,1.055,0,0,0,21.149,21.235Z",
    transform: "translate(0.181 1.119)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M21.5,9.041a1.055,1.055,0,1,0,0-2.111H18.335a1.055,1.055,0,1,0,0,2.111Z",
    transform: "translate(0.958 0.384)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M4.325,17.5H7.492a1.055,1.055,0,1,0,0-2.111H4.325a1.055,1.055,0,0,0,0,2.111Z",
    transform: "translate(0.181 0.853)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M9.385,15.39a1.055,1.055,0,0,0,0,2.111h3.166a1.055,1.055,0,0,0,0-2.111Z",
    transform: "translate(0.462 0.853)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M4.325,26.49a1.055,1.055,0,0,0,0,2.111H7.492a1.055,1.055,0,1,0,0-2.111Z",
    transform: "translate(0.181 1.469)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M17.483,28H15.435a1.055,1.055,0,0,0-.76,1.784,1.055,1.055,0,0,0,.76,1.784h2.048a1.055,1.055,0,0,0,.718-1.752A1.055,1.055,0,0,0,17.483,28Z",
    transform: "translate(0.797 1.552)",
    fill: "#efc700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M13.38,16.445A1.055,1.055,0,0,0,14.435,17.5h7.187a1.055,1.055,0,0,0,0-2.111H14.435A1.055,1.055,0,0,0,13.38,16.445Z",
    transform: "translate(0.742 0.853)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M4.325,12.941h11.05a1.055,1.055,0,0,0,0-2.111H4.325a1.055,1.055,0,1,0,0,2.111Z",
    transform: "translate(0.181 0.601)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M30.829,5.953a1.055,1.055,0,0,0-.887-.211,2.913,2.913,0,0,1-2.66-.823,3.652,3.652,0,0,1-.971-3.3l.074-.359A1.051,1.051,0,0,0,25.33,0H1.055A1.055,1.055,0,0,0,0,1.055V39.769a1.055,1.055,0,0,0,1.055,1.055H23.6a1.055,1.055,0,1,0,0-2.111H2.111V2.111H24.138a5.678,5.678,0,0,0,1.657,4.306,5.1,5.1,0,0,0,3.3,1.488v29.32a1.055,1.055,0,1,0,2.111,0V6.776A1.055,1.055,0,0,0,30.829,5.953Z",
    transform: "translate(0 0)",
    fill: "#1787e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "bill_statement",
    transform: "translate(235 -99.528)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 616.5, 621.03)",
    filter: "url(#Rectangle_43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43-2",
    "data-name": "Rectangle 43",
    width: 107.126,
    height: 107.126,
    rx: 5,
    transform: "translate(134.5 3.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Modal-4",
    "data-name": "Modal",
    transform: "translate(805 705)",
    fill: "#636363",
    fontSize: 14,
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontWeight: 700,
    letterSpacing: "0.017em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -30.912,
    y: 0
  }, "View Bill/"), /*#__PURE__*/React.createElement("tspan", {
    x: -33.714,
    y: 17
  }, "Statement")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-4",
    "data-name": "Layer 2",
    transform: "translate(789 644.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-4",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M23.738,25.28l-2.533,2.681a3.926,3.926,0,0,0,0,5.351,3.462,3.462,0,0,0,5.077,0,3.926,3.926,0,0,0,0-5.351Z",
    transform: "translate(1.117 1.401)",
    fill: "#efc700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M4.325,9.041h11.05a1.055,1.055,0,0,0,0-2.111H4.325a1.055,1.055,0,1,0,0,2.111Z",
    transform: "translate(0.181 0.384)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M21.149,21.235a1.055,1.055,0,0,0-1.055-1.055H4.325a1.055,1.055,0,0,0,0,2.111H20.094A1.055,1.055,0,0,0,21.149,21.235Z",
    transform: "translate(0.181 1.119)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M21.5,9.041a1.055,1.055,0,1,0,0-2.111H18.335a1.055,1.055,0,1,0,0,2.111Z",
    transform: "translate(0.958 0.384)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M4.325,17.5H7.492a1.055,1.055,0,1,0,0-2.111H4.325a1.055,1.055,0,0,0,0,2.111Z",
    transform: "translate(0.181 0.853)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M9.385,15.39a1.055,1.055,0,0,0,0,2.111h3.166a1.055,1.055,0,0,0,0-2.111Z",
    transform: "translate(0.462 0.853)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M4.325,26.49a1.055,1.055,0,0,0,0,2.111H7.492a1.055,1.055,0,1,0,0-2.111Z",
    transform: "translate(0.181 1.469)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M17.483,28H15.435a1.055,1.055,0,0,0-.76,1.784,1.055,1.055,0,0,0,.76,1.784h2.048a1.055,1.055,0,0,0,.718-1.752A1.055,1.055,0,0,0,17.483,28Z",
    transform: "translate(0.797 1.552)",
    fill: "#efc700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M13.38,16.445A1.055,1.055,0,0,0,14.435,17.5h7.187a1.055,1.055,0,0,0,0-2.111H14.435A1.055,1.055,0,0,0,13.38,16.445Z",
    transform: "translate(0.742 0.853)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M4.325,12.941h11.05a1.055,1.055,0,0,0,0-2.111H4.325a1.055,1.055,0,1,0,0,2.111Z",
    transform: "translate(0.181 0.601)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M30.829,5.953a1.055,1.055,0,0,0-.887-.211,2.913,2.913,0,0,1-2.66-.823,3.652,3.652,0,0,1-.971-3.3l.074-.359A1.051,1.051,0,0,0,25.33,0H1.055A1.055,1.055,0,0,0,0,1.055V39.769a1.055,1.055,0,0,0,1.055,1.055H23.6a1.055,1.055,0,1,0,0-2.111H2.111V2.111H24.138a5.678,5.678,0,0,0,1.657,4.306,5.1,5.1,0,0,0,3.3,1.488v29.32a1.055,1.055,0,1,0,2.111,0V6.776A1.055,1.055,0,0,0,30.829,5.953Z",
    transform: "translate(0 0)",
    fill: "#1787e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "new_connection",
    transform: "translate(363.524 -233.341)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 475.98, 476.84)",
    filter: "url(#Rectangle_42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42-2",
    "data-name": "Rectangle 42",
    width: 107.126,
    height: 107.126,
    rx: 5,
    transform: "translate(153.02 147.69)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Modal-5",
    "data-name": "Modal",
    transform: "translate(683 705)",
    fill: "#636363",
    fontSize: 14,
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontWeight: 700,
    letterSpacing: "0.017em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -45.458,
    y: 0
  }, "Apply for new"), /*#__PURE__*/React.createElement("tspan", {
    x: -36.239,
    y: 17
  }, "connection")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-5",
    "data-name": "Layer 2",
    transform: "translate(665 642.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-5",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M27.273,30.278,23.157,25.94,19.03,30.278a6.333,6.333,0,0,0,0,8.676,5.6,5.6,0,0,0,8.243,0A6.333,6.333,0,0,0,27.273,30.278Zm-2.111,5.129h-.918v.918a1.055,1.055,0,0,1-2.111,0v-.918H21.2a1.055,1.055,0,1,1,0-2.111h.918v-.96a1.055,1.055,0,0,1,2.111,0v.918h.918a1.055,1.055,0,0,1,0,2.111Z",
    transform: "translate(0.984 1.439)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M14.777,40.824H2.893a1.055,1.055,0,0,1-1.055-.76C1.532,39.009-5.55,13.678,10.1.253A1.055,1.055,0,0,1,10.83,0H34.609a1.055,1.055,0,0,1,.823,1.72c-.095.106-8.8,11.019-9.9,23.969a1.059,1.059,0,1,1-2.111-.179c.908-10.649,6.512-19.737,9.087-23.4H11.22C-1.645,13.5,2.672,34.47,3.716,38.713H14.777a1.055,1.055,0,0,1,0,2.111Z",
    transform: "translate(0.023 0.001)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M22.643,5.481H11.455a1.055,1.055,0,1,1,0-2.111H22.643a1.055,1.055,0,1,1,0,2.111Z",
    transform: "translate(0.601 0.188)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M19.325,9.111H8.105A1.055,1.055,0,1,1,8.105,7H19.325a1.055,1.055,0,1,1,0,2.111Z",
    transform: "translate(0.415 0.389)",
    fill: "#efc700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M24.9,9.111H21.055a1.055,1.055,0,1,1,0-2.111h3.863a1.055,1.055,0,0,1,0,2.111Z",
    transform: "translate(1.133 0.389)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M15.385,27.051H4.165a1.055,1.055,0,1,1,0-2.111H15.385a1.055,1.055,0,1,1,0,2.111Z",
    transform: "translate(0.197 1.383)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M20.961,27.051H17.055a1.055,1.055,0,1,1,0-2.111h3.905a1.055,1.055,0,1,1,0,2.111Z",
    transform: "translate(0.911 1.383)",
    fill: "#efc700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M8.588,17.111H4.725a1.055,1.055,0,1,1,0-2.111H8.588a1.055,1.055,0,1,1,0,2.111Z",
    transform: "translate(0.228 0.832)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M15.458,17.111H11.6A1.055,1.055,0,1,1,11.6,15h3.863a1.055,1.055,0,1,1,0,2.111Z",
    transform: "translate(0.608 0.832)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M22.118,17.111H18.255a1.055,1.055,0,1,1,0-2.111h3.863a1.055,1.055,0,1,1,0,2.111Z",
    transform: "translate(0.978 0.832)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M17.365,13.331H6.145a1.055,1.055,0,1,1,0-2.111H17.365a1.055,1.055,0,1,1,0,2.111Z",
    transform: "translate(0.306 0.623)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M15.275,22.051H4.055a1.055,1.055,0,1,1,0-2.111H15.275a1.055,1.055,0,1,1,0,2.111Z",
    transform: "translate(0.191 1.106)",
    fill: "#1787e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "jisomee_meter",
    transform: "translate(605.874 -224.826)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 233.63, 468.33)",
    filter: "url(#Rectangle_39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39-2",
    "data-name": "Rectangle 39",
    width: 107.126,
    height: 107.126,
    rx: 5,
    transform: "translate(27.37 155.67)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Modal-6",
    "data-name": "Modal",
    transform: "translate(315 705)",
    fill: "#636363",
    fontSize: 14,
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontWeight: 700,
    letterSpacing: "0.017em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -26.936,
    y: 0
  }, "Jisomee"), /*#__PURE__*/React.createElement("tspan", {
    x: -19.059,
    y: 17
  }, "meter")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-6",
    "data-name": "Layer 2",
    transform: "translate(294 640.887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-6",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M20.549,0A20.549,20.549,0,1,0,41.1,20.549,20.549,20.549,0,0,0,20.549,0Zm0,38.988A18.438,18.438,0,1,1,38.988,20.549,18.438,18.438,0,0,1,20.549,38.988Z",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M22.569,19.625a2.945,2.945,0,1,0-2.945,2.945,2.945,2.945,0,0,0,2.945-2.945Zm-3.778,0a.834.834,0,1,1,.834.834.834.834,0,0,1-.834-.834Z",
    transform: "translate(0.925 0.925)",
    fill: "#efc700"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 2.976,
    height: 4.422,
    rx: 0.25,
    transform: "translate(13.573 10.881)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 2.976,
    height: 4.422,
    rx: 0.25,
    transform: "translate(16.95 10.881)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 2.976,
    height: 4.422,
    rx: 0.25,
    transform: "translate(20.328 10.881)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 2.976,
    height: 4.422,
    rx: 0.25,
    transform: "translate(23.705 10.881)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M19.525,7.738a1.055,1.055,0,0,0,1.055-1.055V4.265a1.055,1.055,0,0,0-2.111,0V6.682A1.055,1.055,0,0,0,19.525,7.738Z",
    transform: "translate(1.024 0.178)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M15.184,7.392a1.055,1.055,0,0,0,1.055.781,1.15,1.15,0,0,0,.274,0,1.055,1.055,0,0,0,.749-1.288l-.623-2.332a1.071,1.071,0,1,0-2.079.517Z",
    transform: "translate(0.805 0.207)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M12.19,8.934a1.055,1.055,0,1,0,1.826-1.055l-1.2-2.111a1.051,1.051,0,1,0-1.8,1.077Z",
    transform: "translate(0.601 0.29)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M9.688,11.176a1.056,1.056,0,1,0,1.488-1.5L9.477,8.01A1.055,1.055,0,0,0,8.01,9.477Z",
    transform: "translate(0.434 0.434)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M5.788,12.812l2.111,1.2A1.055,1.055,0,1,0,8.954,12.19L6.843,11.008a1.045,1.045,0,1,0-1.055,1.8Z",
    transform: "translate(0.292 0.602)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M4.521,16.6l2.332.623a1.151,1.151,0,0,0,.264,0,1.064,1.064,0,0,0,.274-2.111L5.07,14.562A1.055,1.055,0,0,0,4.521,16.6Z",
    transform: "translate(0.208 0.805)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M6.682,20.581a1.055,1.055,0,0,0,0-2.111H4.265a1.055,1.055,0,0,0,0,2.111Z",
    transform: "translate(0.178 1.024)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M8.141,22.611a1.055,1.055,0,0,0-1.288-.749l-2.332.623a1.058,1.058,0,0,0,.306,2.079,1.15,1.15,0,0,0,.274,0l2.332-.633a1.055,1.055,0,0,0,.707-1.319Z",
    transform: "translate(0.207 1.21)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M9.325,25.488A1.055,1.055,0,0,0,7.879,25.1L5.768,26.3a1.059,1.059,0,1,0,1.055,1.836l2.111-1.214a1.055,1.055,0,0,0,.391-1.435Z",
    transform: "translate(0.29 1.383)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M11.183,27.956a1.055,1.055,0,0,0-1.5,0l-1.668,1.7a1.06,1.06,0,0,0,1.467,1.53l1.7-1.741A1.055,1.055,0,0,0,11.183,27.956Z",
    transform: "translate(0.427 1.532)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M13.637,29.848a1.055,1.055,0,0,0-1.446.38l-1.2,2.111a1.055,1.055,0,1,0,1.826,1.055l1.2-2.111A1.055,1.055,0,0,0,13.637,29.848Z",
    transform: "translate(0.601 1.646)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M16.472,31a1.055,1.055,0,0,0-1.288.749l-.623,2.417a1.055,1.055,0,0,0,.739,1.288.866.866,0,0,0,.274,0,1.055,1.055,0,0,0,1.055-.781l.623-2.332A1.055,1.055,0,0,0,16.472,31Z",
    transform: "translate(0.805 1.716)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M19.525,31.44A1.055,1.055,0,0,0,18.47,32.5v2.417a1.055,1.055,0,0,0,2.111,0V32.5A1.055,1.055,0,0,0,19.525,31.44Z",
    transform: "translate(1.024 1.743)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M23.9,31.783a1.051,1.051,0,1,0-2.037.517l.623,2.332a1.055,1.055,0,0,0,1.055.781.866.866,0,0,0,.274,0,1.055,1.055,0,0,0,.718-1.245Z",
    transform: "translate(1.21 1.717)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M26.922,30.226A1.055,1.055,0,0,0,25.1,31.281l1.2,2.111a1.059,1.059,0,1,0,1.836-1.055Z",
    transform: "translate(1.384 1.648)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M29.441,27.953a1.055,1.055,0,0,0-1.488,1.488l1.7,1.741a1.071,1.071,0,1,0,1.53-1.5Z",
    transform: "translate(1.535 1.535)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M33.372,26.3l-2.111-1.2a1.055,1.055,0,0,0-1.055,1.826l2.111,1.214A1.059,1.059,0,0,0,33.372,26.3Z",
    transform: "translate(1.647 1.384)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M34.663,22.485l-2.332-.623a1.055,1.055,0,1,0-.549,2.037l2.332.633a1.214,1.214,0,0,0,.274,0,1.037,1.037,0,0,0,.274-2.048Z",
    transform: "translate(1.718 1.21)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M34.912,18.47H32.5a1.055,1.055,0,1,0,0,2.111h2.417a1.055,1.055,0,0,0,0-2.111Z",
    transform: "translate(1.743 1.024)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M31,16.472a1.055,1.055,0,0,0,1.055.792,1.34,1.34,0,0,0,.274,0l2.332-.623a1.069,1.069,0,0,0-.5-2.079l-2.332.623A1.055,1.055,0,0,0,31,16.472Z",
    transform: "translate(1.717 0.806)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M29.848,13.638a1.055,1.055,0,0,0,1.435.38l2.111-1.2a1.055,1.055,0,1,0-1.055-1.826l-2.111,1.2a1.055,1.055,0,0,0-.38,1.446Z",
    transform: "translate(1.646 0.6)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M27.956,11.183a1.057,1.057,0,0,0,1.488,0l1.741-1.7a1.049,1.049,0,0,0-1.5-1.467L27.956,9.695A1.055,1.055,0,0,0,27.956,11.183Z",
    transform: "translate(1.533 0.427)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M25.488,9.325a1.055,1.055,0,0,0,1.435-.391l1.214-2.111A1.059,1.059,0,0,0,26.3,5.768L25.1,7.879a1.055,1.055,0,0,0,.391,1.446Z",
    transform: "translate(1.383 0.29)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M22.611,8.141a1.214,1.214,0,0,0,.274,0,1.055,1.055,0,0,0,1.055-.781l.591-2.29a1.059,1.059,0,1,0-2.048-.538l-.623,2.332A1.055,1.055,0,0,0,22.611,8.141Z",
    transform: "translate(1.21 0.207)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M20.145,24.52a1.055,1.055,0,1,0,0,2.111h2.892a1.055,1.055,0,0,0,0-2.111Z",
    transform: "translate(1.058 1.359)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M25.09,27.156a.222.222,0,0,0,.116.232.2.2,0,0,0,.106,0,.3.3,0,0,0,.137,0,.232.232,0,0,0,.169.19h.053a.253.253,0,0,0,.179-.095.222.222,0,0,0,.211.148.232.232,0,0,0,.211-.148.211.211,0,0,0,.169.095H26.5a.243.243,0,0,0,.158-.19.3.3,0,0,0,.137,0,.243.243,0,0,0,.116,0,.211.211,0,0,0,.106-.232h.084a.232.232,0,0,0,.158-.063.211.211,0,0,0,0-.253h0a.222.222,0,0,0,.2-.116.211.211,0,0,0,0-.253.2.2,0,0,0,.19-.158.232.232,0,0,0-.074-.232.232.232,0,0,0,0-.422.232.232,0,0,0,.074-.232.243.243,0,0,0-.179-.169.231.231,0,0,0-.243-.348.211.211,0,0,0,0-.253.222.222,0,0,0-.243,0,.211.211,0,0,0-.106-.232.222.222,0,0,0-.253,0,.222.222,0,0,0-.4-.106.223.223,0,0,0-.412,0,.222.222,0,0,0-.232-.084.232.232,0,0,0-.169.19.211.211,0,0,0-.243,0,.222.222,0,0,0-.116.232.222.222,0,0,0-.243,0,.243.243,0,0,0,0,.253.222.222,0,0,0-.243.106.243.243,0,0,0,0,.243.243.243,0,0,0-.179.169.232.232,0,0,0,.074.232.232.232,0,0,0,0,.422.232.232,0,0,0-.074.232.211.211,0,0,0,.19.158.243.243,0,0,0,.2.369h0a.211.211,0,0,0,0,.253.232.232,0,0,0,.158.063A.2.2,0,0,0,25.09,27.156Z",
    transform: "translate(1.349 1.34)",
    fill: "#efc700"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "buy_water_tokens",
    transform: "translate(722.973 -100)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 176.53, 335.5)",
    filter: "url(#Path_184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_184-2",
    "data-name": "Path 184",
    d: "M5,0h97.126a5,5,0,0,1,5,5v97.126a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
    transform: "translate(206.47 288.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Modal-7",
    "data-name": "Modal",
    transform: "translate(437 705)",
    fill: "#636363",
    fontSize: 14,
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontWeight: 700,
    letterSpacing: "0.017em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32.951,
    y: 0
  }, "Buy water"), /*#__PURE__*/React.createElement("tspan", {
    x: -21.828,
    y: 17
  }, "tokens")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-7",
    "data-name": "Layer 2",
    transform: "translate(419 641.942)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-7",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M21.551,9l-8.517,8.992a13.087,13.087,0,0,0,0,17.795,11.61,11.61,0,0,0,17.045,0,13.1,13.1,0,0,0,0-17.805Zm7,25.33a9.5,9.5,0,0,1-13.984,0,10.966,10.966,0,0,1,0-14.9l6.987-7.388,7,7.388h0a10.966,10.966,0,0,1,0,14.955Z",
    transform: "translate(0.527 0.499)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M28.608,11.61a4.433,4.433,0,0,0,3.166-1.4,4.971,4.971,0,0,0,0-6.765L28.608,0,25.389,3.388a4.992,4.992,0,0,0,0,6.765,4.433,4.433,0,0,0,3.219,1.456Z",
    transform: "translate(1.332)",
    fill: "#efc700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M11.261,7.759,6.575,2.82,1.9,7.759a7.145,7.145,0,0,0,0,9.7,6.4,6.4,0,0,0,9.362,0,7.145,7.145,0,0,0,0-9.7ZM9.72,16a4.222,4.222,0,0,1-6.333,0,5,5,0,0,1,0-6.8L6.554,5.891,9.72,9.205h0a4.971,4.971,0,0,1,0,6.8Z",
    transform: "translate(-0.002 0.156)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M24.9,24.7h-2.66V22.055a1.055,1.055,0,0,0-2.111,0v2.67h-2.67a1.055,1.055,0,1,0,0,2.111h2.67v2.607a1.055,1.055,0,0,0,2.111,0V26.815H24.9a1.055,1.055,0,1,0,0-2.111Z",
    transform: "translate(0.907 1.164)",
    fill: "#efc700"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "lipa_maji",
    transform: "translate(706 -359)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 133.5, 602.5)",
    filter: "url(#Path_35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35-2",
    "data-name": "Path 35",
    d: "M5.277,0h96.572a5.277,5.277,0,0,1,5.277,5.277v96.572a5.277,5.277,0,0,1-5.277,5.277H5.277A5.277,5.277,0,0,1,0,101.849V5.277A5.277,5.277,0,0,1,5.277,0Z",
    transform: "translate(4.5 21.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Modal-8",
    "data-name": "Modal",
    transform: "translate(192 705)",
    fill: "#636363",
    fontSize: 14,
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontWeight: 700,
    letterSpacing: "0.017em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -29.36,
    y: 0
  }, "Lipa maji")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-8",
    "data-name": "Layer 2",
    transform: "translate(177 640.887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-8",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M17.478,39.156,13.52,36.613a1.055,1.055,0,0,0-1.14,0l-3.4,2.174L5.594,36.613a1.055,1.055,0,0,0-1.2,0l-2.28,1.741V3.261L4.443,4.77a1.055,1.055,0,0,0,1.15,0L8.982,2.586l3.4,2.185a1.055,1.055,0,0,0,1.182,0l3.325-2.417,3.377,2.385a1.055,1.055,0,0,0,1.182,0l2.332-1.509v19.99a1.055,1.055,0,1,0,2.111,0V1.33A1.055,1.055,0,0,0,24.275.443L20.908,2.607,17.52.2A1.055,1.055,0,0,0,16.3.2L12.918,2.607,9.552.443a1.055,1.055,0,0,0-1.108,0L5.024,2.628,1.625.443A1.055,1.055,0,0,0,0,1.33V40.454a1.055,1.055,0,0,0,.58.95,1.055,1.055,0,0,0,.475.106,1.055,1.055,0,0,0,.633-.211l3.377-2.522,3.346,2.111a1.055,1.055,0,0,0,1.14,0l3.4-2.174,3.388,2.174a1.055,1.055,0,0,0,1.14-1.773Z",
    transform: "translate(0 -0.005)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M26.262,26.991,23.718,24.31l-2.544,2.681a3.947,3.947,0,0,0,0,5.351,3.472,3.472,0,0,0,5.087,0,3.926,3.926,0,0,0,0-5.351Z",
    transform: "translate(1.116 1.343)",
    fill: "#efc700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M4.305,8.111h11.05a1.055,1.055,0,0,0,0-2.111H4.305a1.055,1.055,0,1,0,0,2.111Z",
    transform: "translate(0.18 0.328)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M20.074,19.21H4.305a1.055,1.055,0,0,0,0,2.111H20.074a1.055,1.055,0,0,0,0-2.111Z",
    transform: "translate(0.18 1.06)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M21.482,6H18.315a1.055,1.055,0,0,0,0,2.111h3.166a1.055,1.055,0,1,0,0-2.111Z",
    transform: "translate(0.957 0.328)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M4.305,14.42a1.055,1.055,0,0,0,0,2.111H7.472a1.055,1.055,0,0,0,0-2.111Z",
    transform: "translate(0.18 0.794)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M9.355,14.42a1.055,1.055,0,0,0,0,2.111h3.166a1.055,1.055,0,0,0,0-2.111Z",
    transform: "translate(0.46 0.794)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M7.432,27.641a1.055,1.055,0,1,0,0-2.111H4.265a1.055,1.055,0,1,0,0,2.111Z",
    transform: "translate(0.178 1.41)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M17.625,27.18H15.514a1.055,1.055,0,0,0-.834.443l.517-1.309a1.1,1.1,0,1,0-2.111-.623l-1.6,5.15a1.055,1.055,0,0,0,.7,1.319.981.981,0,0,0,.306,0,1.055,1.055,0,0,0,1.055-.749l.992-3.166a1.055,1.055,0,0,0,.285.675,1.045,1.045,0,0,0,.749,1.784h2.111a1.045,1.045,0,0,0,.749-1.784,1.028,1.028,0,0,0-.8-1.741Z",
    transform: "translate(0.634 1.375)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M14.415,16.531H21.6a1.055,1.055,0,0,0,0-2.111H14.415a1.055,1.055,0,0,0,0,2.111Z",
    transform: "translate(0.741 0.794)",
    fill: "#1787e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M16.411,10.925A1.055,1.055,0,0,0,15.356,9.87H4.305a1.055,1.055,0,0,0,0,2.111h11.05A1.055,1.055,0,0,0,16.411,10.925Z",
    transform: "translate(0.18 0.542)",
    fill: "#1787e0"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesA);
export default __webpack_public_path__ + "static/media/services-a.a552175770f836cd893ee51e99827a33.svg";
export { ForwardRef as ReactComponent };